// src/features/userManagement/services/userManagementService.js
//
// Org-scoped sub-user management API client.
// All calls go directly to IAM with the Bearer token from localStorage
// (mirrors the pattern used in authSlice.js loginUser thunk).

import axios from 'axios';
import { API as ApiUrls } from '../../../utils/apiUrls';

function getToken() {
  return localStorage.getItem('authToken') || '';
}

function authHeaders() {
  return { Authorization: getToken() };
}

/**
 * List all sub-users in the merchant's organization.
 * @param {number} organizationId
 * @param {{ user_type?: string, user_status_id?: number }} params
 */
export async function listOrgUsers(organizationId, params = {}) {
  const url = ApiUrls.iamOrgUsersList(organizationId);
  const resp = await axios.get(url, { headers: authHeaders(), params });
  return resp.data; // Array of UserResponse
}

/**
 * Create a new sub-user in the merchant's organization.
 * @param {number} organizationId
 * @param {{ username: string, password: string, email: string, firstname: string, lastname: string, user_type: string, role_id?: number }} request
 */
export async function createOrgUser(organizationId, request) {
  const url = ApiUrls.iamOrgUserCreate(organizationId);
  const resp = await axios.post(url, request, { headers: authHeaders() });
  return resp.data;
}

/**
 * Update a sub-user's details.
 * @param {number} organizationId
 * @param {string} clientId
 * @param {{ email?: string, firstname?: string, lastname?: string, user_type?: string }} request
 */
export async function updateOrgUser(organizationId, clientId, request) {
  const url = ApiUrls.iamOrgUserUpdate(organizationId, clientId);
  const resp = await axios.put(url, request, { headers: authHeaders() });
  return resp.data;
}

/**
 * Update a sub-user's status.
 * @param {number} organizationId
 * @param {string} clientId
 * @param {{ user_status_id: number, reason?: string }} request
 */
export async function updateOrgUserStatus(organizationId, clientId, request) {
  const url = ApiUrls.iamOrgUserStatus(organizationId, clientId);
  const resp = await axios.put(url, request, { headers: authHeaders() });
  return resp.data;
}

/**
 * Soft-delete a sub-user.
 * @param {number} organizationId
 * @param {string} clientId
 */
export async function deleteOrgUser(organizationId, clientId) {
  const url = ApiUrls.iamOrgUserDelete(organizationId, clientId);
  await axios.delete(url, { headers: authHeaders() });
}
